import React, { } from 'react';
import { Modal, Button } from 'bootstrap-4-react';

function ThanksModal(){
    return (
        <div>
          <Modal id="Modal" fade>
            <Modal.Dialog centered>
              <Modal.Content>
                <Modal.Header style={{background: "#28a745"}}>
                  <Modal.Title style={{color: 'white', fontWeight: 'bold'}}>Спасибо за регистрацию!</Modal.Title>
                  <Modal.Close>
                    <span aria-hidden="true">&times;</span>
                  </Modal.Close>
                </Modal.Header>
                <Modal.Body style={{color: 'black'}}>
                <p>Благодарим за желание к нам присоединиться! Ссылка для входа на вебинар уже отправляется на указанный вами адрес электронной почты. Если ссылка не будет получена, сообщите, пожалуйста об этом на адрес marketing@sprayplast.ru</p>
                </Modal.Body>
                <Modal.Footer>
                  <Button danger data-dismiss="modal">Закрыть</Button>
                </Modal.Footer>
              </Modal.Content>
            </Modal.Dialog>
          </Modal>
        </div>
      )
}
    
export default ThanksModal